module.exports = __webpack_public_path__ + "media/images/payments/paybox-171a190d8661f72551c97cfd023f59d5.svg";